module.exports = __webpack_public_path__ + "img/2022071222230060697m.3454fffe.jpg";